import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import {
  SendOutlined,
  DashboardOutlined,
  SmileOutlined,
  ScissorOutlined,
  ZhihuOutlined,
  UsergroupDeleteOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";

const SidebarContent = (props) => {
  const location = useLocation();
  const { collapsed } = props;

  return (
    <Menu
      mode="inline"
      theme="dark"
      inlineCollapsed={collapsed}
      selectedKeys={location.pathname}
    >
      {/* <Menu.Item key="1" icon={<DashboardOutlined />}>
        <Link to="/" style={{ color: "#fff" }}>
          Dashboard
        </Link>
      </Menu.Item> */}

      <Menu.Item key="/services" icon={<SendOutlined />}>
        <Link to="/services" style={{ color: "#fff" }}>
          Services
        </Link>
      </Menu.Item>

      {/* <Menu.Item key="/refund" icon={<SendOutlined />}>
        <Link to="/refund" style={{ color: "#fff" }}>
          Client Refund
        </Link>
      </Menu.Item> */}
    </Menu>
  );
};
export default SidebarContent;
